import { Side } from "./index50.js";
var doubleLoadOptions = [
	{
		start: true,
		right: true,
		load: void 0
	},
	{
		start: false,
		right: true,
		load: void 0
	},
	{
		start: true,
		right: false,
		load: void 0
	},
	{
		start: false,
		right: false,
		load: void 0
	}
];
var singleLoadOptions = [
	{
		start: true,
		right: true,
		load: Side.right
	},
	{
		start: false,
		right: true,
		load: Side.right
	},
	{
		start: true,
		right: false,
		load: Side.right
	},
	{
		start: false,
		right: false,
		load: Side.right
	},
	{
		start: true,
		right: true,
		load: Side.left
	},
	{
		start: false,
		right: true,
		load: Side.left
	},
	{
		start: true,
		right: false,
		load: Side.left
	},
	{
		start: false,
		right: false,
		load: Side.left
	}
];
const ThreadOptions = {
	doubleLoadOptions,
	singleLoadOptions,
	allLoadOptions: [...doubleLoadOptions, ...singleLoadOptions]
};
export { ThreadOptions };

//# sourceMappingURL=index51.js.map